import { type OcrPageSection } from "./types";

/**
 * Splits OCR text on `--- Page N ---` markers into per-page sections.
 * Falls back to a single section when no markers are found.
 */
export function parseOcrPages(text: string): OcrPageSection[] {
  const parts = text.split(/--- Page (\d+) ---/);
  if (parts.length <= 1) return [{ pageNumber: 1, content: text }];

  const sections: OcrPageSection[] = [];
  for (let i = 1; i < parts.length; i += 2) {
    sections.push({
      pageNumber: parseInt(parts[i], 10),
      content: parts[i + 1] ?? "",
    });
  }
  return sections;
}
